<template>
    <!-- 储值消费统计－页面 -->
    <div>
        <content-view v-show="$utils.renderWhen(this,'storedConsumStatistics')">
            <div slot="header" v-if="true">
                <a-form :form="filterForm" layout="inline" class="store-one-form">
                    <a-form-item label="日期">
                        <a-range-picker style="width:282px" format="YYYY/MM/DD" v-decorator="['dateTime',{initialValue: [$moment().subtract(1, 'days'),$moment().subtract(1, 'days')]}]" />
                    </a-form-item>
                    <a-form-item label="门店" :labelCol="{span: 6}" :wrapperCol="{span: 18}">
                        <a-select allowClear :options="shopList" v-decorator="['shopId']" placeholder="请选择" style="width: 100%;" />
                    </a-form-item>
                    <a-form-item class="wrap-header-button">
                        <a-button @click="getAll" class="mr8" type="primary">筛选</a-button>
                        <a-button @click="handleReset">重置</a-button>
                    </a-form-item>
                </a-form>
            </div>
            <div>
            <a-card :bordered="false">
                <a-alert slot="title" type="warning" showIcon>
                    <template slot="message">
                        <span class="text-primary">餐饮实收：{{pointDetail.restauranIncomeSum || 0}}元</span>
                        <a-divider type="vertical" />
                        <span class="text-primary mr8">{{pointDetail.restauranIncomeAllNum || 0}}笔，</span>
                        
                        <span class="text-primary">零售实收：{{pointDetail.retailIncomeSun || 0}}元</span>
                        <a-divider type="vertical" />
                        <span class="text-primary mr8">{{pointDetail.retailIncomeAllNum || 0}}笔，</span>
                        
                        <span class="text-primary">门票实收：{{pointDetail.ticketIncomeSum || 0}}元</span>
                        <a-divider type="vertical" />
                        <span class="text-primary mr8">{{pointDetail.ticketIncomeAllNum || 0}}笔，</span>
                        
                        <span class="text-primary">课程实收：{{pointDetail.courseIncomeSum || 0}}元</span>
                        <a-divider type="vertical" />
                        <span class="text-primary">{{pointDetail.courseIncomeAllNum || 0}}笔</span>
                    </template>
                </a-alert>
                <a-button v-if="getBtnByAuth('storedStatisticsExport')" @click="exportStatistics" :loading="loading" slot="extra" class="ml80">导出</a-button>
                <a-table style="word-break:break-all;" :loading="tableLoading" bordered :dataSource="dataSource" :columns="columns" :pagination="pagination" @change="changePage" :rowKey="(record,index) => index">
                    <span slot="restauranIncome" slot-scope="restauranIncome,row">{{restauranIncome + '元, ' + row.restauranIncomeNum}}笔</span>
                    <span slot="restauranRefund" slot-scope="restauranRefund,row">{{restauranRefund + '元, ' + row.restauranRefundNum}}笔</span>

                    <span slot="retailIncome" slot-scope="retailIncome,row">{{retailIncome + '元, ' + row.retailIncomeNum}}笔</span>
                    <span slot="retailRefund" slot-scope="retailRefund,row">{{retailRefund + '元, ' + row.retailRefundNum}}笔</span>

                    <span slot="ticketIncome" slot-scope="ticketIncome,row">{{ticketIncome + '元, ' + row.ticketIncomeNum}}笔</span>
                    <span slot="ticketRefund" slot-scope="ticketRefund,row">{{ticketRefund + '元, ' + row.ticketRefundNum}}笔</span>

                    <span slot="courseIncome" slot-scope="courseIncome,row">{{courseIncome + '元, ' + row.courseIncomeNum}}笔</span>
                    <span slot="courseRefund" slot-scope="courseRefund,row">{{courseRefund + '元, ' + row.courseRefundNum}}笔</span>
                </a-table>
            </a-card>
            </div>
        </content-view>
        <router-view></router-view>
    </div>
</template>
<script>
const columns = [
    {
        title: '日期',
        dataIndex: 'date'
    },
    {
        title: '门店名称',
        dataIndex: 'shopName'
    },
    {
        title: '餐饮',
        dataIndex: 'restauran',
        children: [
            {
                title: '实际收入',
                dataIndex: 'restauranIncome',
                scopedSlots: { customRender: 'restauranIncome'}
            },
            {
                title: '实际退款',
                dataIndex: 'restauranRefund',
                scopedSlots: { customRender: 'restauranRefund'}
            },
        ]
    },
    {
        title: '零售',
        dataIndex: 'retail',
        children: [
            {
                title: '实际收入',
                dataIndex: 'retailIncome',
                scopedSlots: { customRender: 'retailIncome'}
            },
            {
                title: '实际退款',
                dataIndex: 'retailRefund',
                scopedSlots: { customRender: 'retailRefund'}
            },
        ]
    },
    {
        title: '门票',
        dataIndex: 'ticket',
        children: [
            {
                title: '实际收入',
                dataIndex: 'ticketIncome',
                scopedSlots: { customRender: 'ticketIncome'}
            },
            {
                title: '实际退款',
                dataIndex: 'ticketRefund',
                scopedSlots: { customRender: 'ticketRefund'}
            },
        ]
    },
    {
        title: '课程',
        dataIndex: 'course',
        children: [
            {
                title: '实际收入',
                dataIndex: 'courseIncome',
                scopedSlots: { customRender: 'courseIncome'}
            },
            {
                title: '实际退款',
                dataIndex: 'courseRefund',
                scopedSlots: { customRender: 'courseRefund'}
            },
        ]
    }
];
export default {
    name: "storedRechargeReport",
    components: {},
    props: {},
    data() {
        return {
            columns,
            dataSource:[],
            pagination: {
                showTotal: total => `共 ${total} 条数据`,
                showSizeChanger: true,
                showQuickJumper: true,
                total: 0,
                current: 1,
                pageSize: 20
            },
            shopList: [],
            pointDetail: {},
            searchDetail: {},
            tableLoading: false,
            loading: false,
        };
    },
    computed: {},
    beforeCreate() {
        this.filterForm = this.$form.createForm(this);
    },
    created() {},
    mounted() {
        this.getShopList()
        this.getAll()
    },
    methods: {
        getAll() {
            this.pagination.current = 1;
            this.getList()
            this.getPointSum()
        },
        getShopList() {
            this.$api.totalPlatform.selectList().then(res => {
                this.shopList = res.map(item => {return {value: item.id, label: item.name}});
                this.shopList.unshift({value: -1, label: '总平台'})
            });
        },
        getPointSum() {
            this.filterForm.validateFields((err,values) => {
                if(!err) {
                    const dateTime = values['dateTime'] ? values['dateTime'] : [];
                    values.startTime = dateTime.length > 0 ? dateTime[0].format('YYYY-MM-DD 00:00:00') : '';
                    values.endTime = dateTime.length > 0 ? dateTime[1].format('YYYY-MM-DD 23:59:59') : '';
                    delete values.dateTime

                    this.$api.statement.storedValueSearchSum({body: values}).then(res => {
                        this.pointDetail = res;
                    })
                }
            })
        },
        /**
         * @changePage 切换table分页
         */
        changePage(page) {
            this.pagination.pageSize = page.pageSize
            this.pagination.current = page.current
            this.getList()
        },
        handleReset() {
            this.filterForm.resetFields();
            this.getAll()
        },
        getList() {
            this.filterForm.validateFields((err,values) => {
                if(!err) {
                    const dateTime = values['dateTime'] ? values['dateTime'] : [];
                    values.startTime = dateTime.length > 0 ? dateTime[0].format('YYYY-MM-DD 00:00:00') : '';
                    values.endTime = dateTime.length > 0 ? dateTime[1].format('YYYY-MM-DD 23:59:59') : '';
                    delete values.dateTime
                    
                    values.pageNum = this.pagination.current
                    values.pageSize = this.pagination.pageSize

                    this.tableLoading = true
                    this.$api.statement.storedValueSearch({body: values}).then(res => {
                        this.tableLoading = false
                        this.dataSource = res.data;
                        this.pagination.total = res.total;
                    }).catch(err => {
                        this.tableLoading = false
                    })
                }
            })
        },
        exportStatistics() {
            this.filterForm.validateFields((err,values) => {
                if(!err) {
                    const dateTime = values['dateTime'] ? values['dateTime'] : [];
                    values.startTime = dateTime.length > 0 ? dateTime[0].format('YYYY-MM-DD 00:00:00') : '';
                    values.endTime = dateTime.length > 0 ? dateTime[1].format('YYYY-MM-DD 23:59:59') : '';
                    delete values.dateTime
                    
                    values.pageNum = 1
                    values.pageSize = 999999
                    this.loading = true;
                    this.$api.statement.exportStoredValue(
                        {
                            body: values
                        },
                        {
                            responseType: "blob"
                        })
                    .then(res => {
                        let a = document.createElement("a");
                        let blob = new Blob([res.data], {
                            type: "application/vnd.ms-excel"
                        });

                        let downloadUrl = window.URL.createObjectURL(blob);

                        let name = this.$route.meta.name + '-' + this.$moment().format('YYYY/MM/DD') + '.xls'

                        a.setAttribute("href", downloadUrl);

                        var reportName = decodeURI(name);

                        a.setAttribute("download", reportName);
                        a.click();
                        this.loading = false
                    }).catch(err => {
                        this.loading = false
                    })
                }
            })
        },
    }
}
</script>
<style lang="scss">
</style>